import * as ambassadorWixTableReservationsV1TimeSlot from './table-reservations-v1-time-slot-time-slots.http.js';
import * as ambassadorWixTableReservationsV1TimeSlotTypes from './table-reservations-v1-time-slot-time-slots.types.js';
import * as ambassadorWixTableReservationsV1TimeSlotUniversalTypes from './table-reservations-v1-time-slot-time-slots.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getTimeSlots(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1TimeSlotUniversalTypes.GetTimeSlotsRequest,
  ambassadorWixTableReservationsV1TimeSlotTypes.GetTimeSlotsRequest,
  ambassadorWixTableReservationsV1TimeSlotUniversalTypes.GetTimeSlotsResponse,
  ambassadorWixTableReservationsV1TimeSlotTypes.GetTimeSlotsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1TimeSlot.getTimeSlots(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/time-slots',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function checkTimeSlot(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1TimeSlotUniversalTypes.CheckTimeSlotRequest,
  ambassadorWixTableReservationsV1TimeSlotTypes.CheckTimeSlotRequest,
  ambassadorWixTableReservationsV1TimeSlotUniversalTypes.CheckTimeSlotResponse,
  ambassadorWixTableReservationsV1TimeSlotTypes.CheckTimeSlotResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1TimeSlot.checkTimeSlot(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/check-time-slot',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getScheduledTimeSlots(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1TimeSlotUniversalTypes.GetScheduledTimeSlotsRequest,
  ambassadorWixTableReservationsV1TimeSlotTypes.GetScheduledTimeSlotsRequest,
  ambassadorWixTableReservationsV1TimeSlotUniversalTypes.GetScheduledTimeSlotsResponse,
  ambassadorWixTableReservationsV1TimeSlotTypes.GetScheduledTimeSlotsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1TimeSlot.getScheduledTimeSlots(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/scheduled-time-slots',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TimeSlot as TimeSlotOriginal,
  TimeSlotTableCombination as TimeSlotTableCombinationOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  MaybeTableCombinations as MaybeTableCombinationsOriginal,
  GetTimeSlotsRequest as GetTimeSlotsRequestOriginal,
  GetTimeSlotsResponse as GetTimeSlotsResponseOriginal,
  CheckReservationDetailsRequest as CheckReservationDetailsRequestOriginal,
  MaybeTableIds as MaybeTableIdsOriginal,
  CheckReservationDetailsResponse as CheckReservationDetailsResponseOriginal,
  TableCombinationAvailability as TableCombinationAvailabilityOriginal,
  TableCombinationConflictType as TableCombinationConflictTypeOriginal,
  TableCombinationConflictTypeWithLiterals as TableCombinationConflictTypeWithLiteralsOriginal,
  ReservationLocationConflictType as ReservationLocationConflictTypeOriginal,
  ReservationLocationConflictTypeWithLiterals as ReservationLocationConflictTypeWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  ExperienceTableCombinationAvailability as ExperienceTableCombinationAvailabilityOriginal,
  ExperienceTableCombinationConflictType as ExperienceTableCombinationConflictTypeOriginal,
  ExperienceTableCombinationConflictTypeWithLiterals as ExperienceTableCombinationConflictTypeWithLiteralsOriginal,
  ExperienceConflictType as ExperienceConflictTypeOriginal,
  ExperienceConflictTypeWithLiterals as ExperienceConflictTypeWithLiteralsOriginal,
  TimeSlotAvailabilityType as TimeSlotAvailabilityTypeOriginal,
  TimeSlotAvailabilityTypeWithLiterals as TimeSlotAvailabilityTypeWithLiteralsOriginal,
  StandardOptions as StandardOptionsOriginal,
  ExperienceOptions as ExperienceOptionsOriginal,
  Table as TableOriginal,
  TableConflict as TableConflictOriginal,
  TableConflictType as TableConflictTypeOriginal,
  TableConflictTypeWithLiterals as TableConflictTypeWithLiteralsOriginal,
  TableCombination as TableCombinationOriginal,
  TableCombinationConflict as TableCombinationConflictOriginal,
  ReservationLocationConflict as ReservationLocationConflictOriginal,
  TableReservedConflict as TableReservedConflictOriginal,
  TimeSlotAvailability as TimeSlotAvailabilityOriginal,
  TimeSlotAvailabilityOptionsOneOf as TimeSlotAvailabilityOptionsOneOfOriginal,
  CheckTimeSlotRequest as CheckTimeSlotRequestOriginal,
  CheckTimeSlotResponse as CheckTimeSlotResponseOriginal,
  V1TimeSlotAvailability as V1TimeSlotAvailabilityOriginal,
  V1TimeSlotAvailabilityOptionsOneOf as V1TimeSlotAvailabilityOptionsOneOfOriginal,
  TimeSlotAvailabilityTimeSlotAvailabilityType as TimeSlotAvailabilityTimeSlotAvailabilityTypeOriginal,
  TimeSlotAvailabilityTimeSlotAvailabilityTypeWithLiterals as TimeSlotAvailabilityTimeSlotAvailabilityTypeWithLiteralsOriginal,
  TimeSlotAvailabilityStandardOptions as TimeSlotAvailabilityStandardOptionsOriginal,
  TimeSlotAvailabilityExperienceOptions as TimeSlotAvailabilityExperienceOptionsOriginal,
  GetScheduledTimeSlotsRequest as GetScheduledTimeSlotsRequestOriginal,
  TimeRange as TimeRangeOriginal,
  GetScheduledTimeSlotsResponse as GetScheduledTimeSlotsResponseOriginal,
} from './table-reservations-v1-time-slot-time-slots.types.js';
